module.exports = ".td-break {\n    word-wrap: break-word;\n}\n\ntable {\n    table-layout: fixed;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/report-list/report-list.component.css
// module id = ./src/app/report-list/report-list.component.css
// module chunks = main